export default __webpack_public_path__ + "static/media/sahil.e3ff9944.jpg";